import { AccessListUser } from '@statsbomb/parachute-types';
import { atom } from 'jotai';
import { entityUsersAtom } from './queries/user';
import { userConfigPermissionsAtom } from './queries/userConfigs';

export const accessListAtom = atom(async get => {
  const [userConfigPermissions, entityUsers] = await Promise.all([
    get(userConfigPermissionsAtom),
    get(entityUsersAtom),
  ]);

  // Users with permissions take precedence so we dedupe by removing matching users from the non permissions user list.
  const permissionUserIds = new Set(userConfigPermissions.map(p => p.id));
  const dedupedEntityUsers = entityUsers.data
    .filter(user => !permissionUserIds.has(user.hudl_user_id))
    .map(user => ({ id: user.hudl_user_id, name: user.name, email: user.email }));

  const accessList: { id: string; name: string; email: string; permission?: AccessListUser['permission'] }[] = [
    ...userConfigPermissions,
    ...dedupedEntityUsers,
  ];

  return accessList;
});
